var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasModule.tests && _vm.testsTodo && _vm.testsTodo.length)?_c('div',{attrs:{"data-cy":"TestsBlock"}},[_c('div',{staticClass:"t-body3 u-colorDarkLightEmphasis u-marginBottom3",attrs:{"data-cy":"TestsBlock__title"}},[_vm._v(" "+_vm._s(_vm.$t('tests.tests_todo'))+" ")]),_c('TestsTodo',{attrs:{"one-line":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }